/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KpisTechnicienResponseDto } from '../../models/kpis-technicien-response-dto';

export interface GetKpisTechnicien$Params {
  id_technicien: string;
  year: number;
  week: number;
}

export function getKpisTechnicien(
  http: HttpClient,
  rootUrl: string,
  params: GetKpisTechnicien$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<KpisTechnicienResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getKpisTechnicien.PATH, 'get');
  if (params) {
    rb.path('id_technicien', params.id_technicien, {});
    rb.path('year', params.year, {});
    rb.path('week', params.week, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KpisTechnicienResponseDto>;
    })
  );
}

getKpisTechnicien.PATH = '/v1/kpisTechnicien/techniciens/{id_technicien}/year/{year}/week/{week}';
